module.exports = __webpack_public_path__ + "images/marketing_site/choose_a_theme.png";